/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createProduct = /* GraphQL */ `
  mutation CreateProduct(
    $input: CreateProductInput!
    $condition: ModelProductConditionInput
  ) {
    createProduct(input: $input, condition: $condition) {
      id
      code
      description
      cost
      price
      createdAt
      updatedAt
    }
  }
`;
export const updateProduct = /* GraphQL */ `
  mutation UpdateProduct(
    $input: UpdateProductInput!
    $condition: ModelProductConditionInput
  ) {
    updateProduct(input: $input, condition: $condition) {
      id
      code
      description
      cost
      price
      createdAt
      updatedAt
    }
  }
`;
export const deleteProduct = /* GraphQL */ `
  mutation DeleteProduct(
    $input: DeleteProductInput!
    $condition: ModelProductConditionInput
  ) {
    deleteProduct(input: $input, condition: $condition) {
      id
      code
      description
      cost
      price
      createdAt
      updatedAt
    }
  }
`;
export const createPharmacy = /* GraphQL */ `
  mutation CreatePharmacy(
    $input: CreatePharmacyInput!
    $condition: ModelPharmacyConditionInput
  ) {
    createPharmacy(input: $input, condition: $condition) {
      id
      code
      description
      enabled
      createdAt
      updatedAt
    }
  }
`;
export const updatePharmacy = /* GraphQL */ `
  mutation UpdatePharmacy(
    $input: UpdatePharmacyInput!
    $condition: ModelPharmacyConditionInput
  ) {
    updatePharmacy(input: $input, condition: $condition) {
      id
      code
      description
      enabled
      createdAt
      updatedAt
    }
  }
`;
export const deletePharmacy = /* GraphQL */ `
  mutation DeletePharmacy(
    $input: DeletePharmacyInput!
    $condition: ModelPharmacyConditionInput
  ) {
    deletePharmacy(input: $input, condition: $condition) {
      id
      code
      description
      enabled
      createdAt
      updatedAt
    }
  }
`;
export const createCustomer = /* GraphQL */ `
  mutation CreateCustomer(
    $input: CreateCustomerInput!
    $condition: ModelCustomerConditionInput
  ) {
    createCustomer(input: $input, condition: $condition) {
      id
      customerId
      name
      contactName
      chargeTo
      createdAt
      updatedAt
    }
  }
`;
export const updateCustomer = /* GraphQL */ `
  mutation UpdateCustomer(
    $input: UpdateCustomerInput!
    $condition: ModelCustomerConditionInput
  ) {
    updateCustomer(input: $input, condition: $condition) {
      id
      customerId
      name
      contactName
      chargeTo
      createdAt
      updatedAt
    }
  }
`;
export const deleteCustomer = /* GraphQL */ `
  mutation DeleteCustomer(
    $input: DeleteCustomerInput!
    $condition: ModelCustomerConditionInput
  ) {
    deleteCustomer(input: $input, condition: $condition) {
      id
      customerId
      name
      contactName
      chargeTo
      createdAt
      updatedAt
    }
  }
`;
export const createContract = /* GraphQL */ `
  mutation CreateContract(
    $input: CreateContractInput!
    $condition: ModelContractConditionInput
  ) {
    createContract(input: $input, condition: $condition) {
      id
      voucherCode
      voucherExpiry
      customerId
      productId
      customer {
        id
        customerId
        name
        contactName
        chargeTo
        createdAt
        updatedAt
      }
      product {
        id
        code
        description
        cost
        price
        createdAt
        updatedAt
      }
      customerAttributes {
        name
        multiList
      }
      createdAt
      updatedAt
    }
  }
`;
export const updateContract = /* GraphQL */ `
  mutation UpdateContract(
    $input: UpdateContractInput!
    $condition: ModelContractConditionInput
  ) {
    updateContract(input: $input, condition: $condition) {
      id
      voucherCode
      voucherExpiry
      customerId
      productId
      customer {
        id
        customerId
        name
        contactName
        chargeTo
        createdAt
        updatedAt
      }
      product {
        id
        code
        description
        cost
        price
        createdAt
        updatedAt
      }
      customerAttributes {
        name
        multiList
      }
      createdAt
      updatedAt
    }
  }
`;
export const deleteContract = /* GraphQL */ `
  mutation DeleteContract(
    $input: DeleteContractInput!
    $condition: ModelContractConditionInput
  ) {
    deleteContract(input: $input, condition: $condition) {
      id
      voucherCode
      voucherExpiry
      customerId
      productId
      customer {
        id
        customerId
        name
        contactName
        chargeTo
        createdAt
        updatedAt
      }
      product {
        id
        code
        description
        cost
        price
        createdAt
        updatedAt
      }
      customerAttributes {
        name
        multiList
      }
      createdAt
      updatedAt
    }
  }
`;
export const createAdditionalItem = /* GraphQL */ `
  mutation CreateAdditionalItem(
    $input: CreateAdditionalItemInput!
    $condition: ModelAdditionalItemConditionInput
  ) {
    createAdditionalItem(input: $input, condition: $condition) {
      id
      contractId
      label
      values
      createdAt
      updatedAt
    }
  }
`;
export const updateAdditionalItem = /* GraphQL */ `
  mutation UpdateAdditionalItem(
    $input: UpdateAdditionalItemInput!
    $condition: ModelAdditionalItemConditionInput
  ) {
    updateAdditionalItem(input: $input, condition: $condition) {
      id
      contractId
      label
      values
      createdAt
      updatedAt
    }
  }
`;
export const deleteAdditionalItem = /* GraphQL */ `
  mutation DeleteAdditionalItem(
    $input: DeleteAdditionalItemInput!
    $condition: ModelAdditionalItemConditionInput
  ) {
    deleteAdditionalItem(input: $input, condition: $condition) {
      id
      contractId
      label
      values
      createdAt
      updatedAt
    }
  }
`;
export const createVaccination = /* GraphQL */ `
  mutation CreateVaccination(
    $input: CreateVaccinationInput!
    $condition: ModelVaccinationConditionInput
  ) {
    createVaccination(input: $input, condition: $condition) {
      id
      pharmacyCode
      chargeTo
      voucherCode
      contractId
      contract {
        id
        voucherCode
        voucherExpiry
        customerId
        productId
        customer {
          id
          customerId
          name
          contactName
          chargeTo
          createdAt
          updatedAt
        }
        product {
          id
          code
          description
          cost
          price
          createdAt
          updatedAt
        }
        customerAttributes {
          name
          multiList
        }
        createdAt
        updatedAt
      }
      vaccinationDate
      patientName
      customerAttributes {
        name
        value
      }
      lastUpdatedBy
      vaccinationYearMonth
      createdAt
      updatedAt
    }
  }
`;
export const updateVaccination = /* GraphQL */ `
  mutation UpdateVaccination(
    $input: UpdateVaccinationInput!
    $condition: ModelVaccinationConditionInput
  ) {
    updateVaccination(input: $input, condition: $condition) {
      id
      pharmacyCode
      chargeTo
      voucherCode
      contractId
      contract {
        id
        voucherCode
        voucherExpiry
        customerId
        productId
        customer {
          id
          customerId
          name
          contactName
          chargeTo
          createdAt
          updatedAt
        }
        product {
          id
          code
          description
          cost
          price
          createdAt
          updatedAt
        }
        customerAttributes {
          name
          multiList
        }
        createdAt
        updatedAt
      }
      vaccinationDate
      patientName
      customerAttributes {
        name
        value
      }
      lastUpdatedBy
      vaccinationYearMonth
      createdAt
      updatedAt
    }
  }
`;
export const deleteVaccination = /* GraphQL */ `
  mutation DeleteVaccination(
    $input: DeleteVaccinationInput!
    $condition: ModelVaccinationConditionInput
  ) {
    deleteVaccination(input: $input, condition: $condition) {
      id
      pharmacyCode
      chargeTo
      voucherCode
      contractId
      contract {
        id
        voucherCode
        voucherExpiry
        customerId
        productId
        customer {
          id
          customerId
          name
          contactName
          chargeTo
          createdAt
          updatedAt
        }
        product {
          id
          code
          description
          cost
          price
          createdAt
          updatedAt
        }
        customerAttributes {
          name
          multiList
        }
        createdAt
        updatedAt
      }
      vaccinationDate
      patientName
      customerAttributes {
        name
        value
      }
      lastUpdatedBy
      vaccinationYearMonth
      createdAt
      updatedAt
    }
  }
`;
export const createPharmacyUser = /* GraphQL */ `
  mutation CreatePharmacyUser(
    $input: CreatePharmacyUserInput!
    $condition: ModelPharmacyUserConditionInput
  ) {
    createPharmacyUser(input: $input, condition: $condition) {
      id
      userEmail
      pharmacyCodes
      enabled
      createdAt
      updatedAt
    }
  }
`;
export const updatePharmacyUser = /* GraphQL */ `
  mutation UpdatePharmacyUser(
    $input: UpdatePharmacyUserInput!
    $condition: ModelPharmacyUserConditionInput
  ) {
    updatePharmacyUser(input: $input, condition: $condition) {
      id
      userEmail
      pharmacyCodes
      enabled
      createdAt
      updatedAt
    }
  }
`;
export const deletePharmacyUser = /* GraphQL */ `
  mutation DeletePharmacyUser(
    $input: DeletePharmacyUserInput!
    $condition: ModelPharmacyUserConditionInput
  ) {
    deletePharmacyUser(input: $input, condition: $condition) {
      id
      userEmail
      pharmacyCodes
      enabled
      createdAt
      updatedAt
    }
  }
`;
